module.exports = __webpack_public_path__ + "static/Stephen-7fe933efebbb919095b9dda7aa98e6b1.jpg";